export default defineNuxtPlugin((nuxtApp) => {
  const { $clientPosthog } = useNuxtApp();

  nuxtApp.hook("vue:error", (error) => {
    if ($clientPosthog) $clientPosthog.captureException(error);
  });
});
